// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9660ea8c","455":"6c226bb7","977":"560c05da"}[chunkId] + ".chunk.js";
};